let defaultCity = "上海";
try {
  if (localStorage.city) {
    defaultCity = localStorage.city;
  }
} catch (e) {}

let unDoneLength = 0;
let receiveData = [];
let todos = [];
let todoTitle = "";
let todoDesc = "";
try {
  const todo = JSON.parse(sessionStorage.getItem("todo"));
  if (todo) {
    todoDesc = todo.desc;
    todoTitle = todo.title;
    todos = todo.documentList;
  }
} catch (e) {}

let userInfo = "";
try {
  // 尝试获取本地是否存在lifeData变量，第一次启动APP时是不存在的
  userInfo =
    sessionStorage.getItem("userInfo") || localStorage.getItem("userInfo");
} catch (e) {}

let homeObj = {};
try {
  if (localStorage.homeObj) {
    console.log("localStorage.homeObj");
    homeObj = JSON.parse(localStorage.homeObj);
  }
} catch (e) {}

let tipsObj = {};
try {
  if (localStorage.tipsObj) {
    tipsObj = JSON.parse(localStorage.tipsObj);
  }
} catch (e) {}

export default {
  city: defaultCity,
  userInfo: JSON.parse(userInfo),
  receiveData: receiveData,
  homeObj: homeObj,
  tipsObj: tipsObj,
  todos,
  todoTitle,
  todoDesc,
  unDoneLength
};



// WEBPACK FOOTER //
// ./src/store/state.js